import { DatastoreProvider, InstanceStack } from 'component/navigation/instance';
import { useInstanceConfig } from 'data/instance-config';
import { storyFeaturesQueryOptions } from 'data/story-features';
import { type RoutePath, useLocalSearchParams } from 'expo-router';

const moduleFn = () => import('feature/article/article-module');

export default function ArticleInstanceAdminLayout() {
    const { siloKey, instanceKey: decodedInstanceKey } =
        useLocalSearchParams<Extract<RoutePath, `/[siloKey]/article/[instanceKey]${string}`>>();
    // Legacy routing code did not perform encoding/decoding of path parameters.
    // Article instance keys need to be re-encoded before use.
    const instanceKey = encodeURIComponent(decodedInstanceKey);
    const instanceConfig = useInstanceConfig({
        siloKey,
        structureKey: 'article',
        instanceKey,
        featuresSource: storyFeaturesQueryOptions,
        moduleFn,
    });
    return (
        <DatastoreProvider {...instanceConfig}>
            <InstanceStack />
        </DatastoreProvider>
    );
}
